import React, { Component } from "react";
import Layout from "../Layout";
import PropagateLoader from "react-spinners/PropagateLoader";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faFilePdf,
  faQuestionCircle,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import {
  Modal,
  Button,
  ButtonGroup,
  Row,
  Col,
  OverlayTrigger,
  Popover,
  Form,
  ButtonToolbar,
} from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ReactTooltip from "react-tooltip";
import Adjunto from "./Adjunto";
import Galeria from "./Galeria";
import ListaAdjuntos from "./ListaAdjuntos";
import ReportePDF from "./ReportePDF";

class F5as extends Component {
  constructor(props) {
    super(props);
    this.GetActionFormat = this.GetActionFormat.bind(this);
    this.state = {
      // Estado relacionado con el modelo
      id: "",
      no_de_expediente: "",
      conducta: "",
      origen: "",
      fecha_de_inicio: null,
      calificacion_de_la_conducta: "",
      fecha_de_remision_del_informe: null,
      seguimiento: "",
      total_de_tomos: 0,
      numero_de_fojas: 0,
      observaciones: "",
      usuario_id: "",
      ambito_id: "",

      // Estados para la ventana modal
      modal: false, // ventana modal generica para modificar y Nuevo cerrada
      modalEliminar: false, //Modal Eliminar
      modalVisualizar: false, //Modal Visualizar
      modalAccion: "", // Acción del boton principal de la ventana modal para el switch
      modalTitle: "", // Titulo para la ventana modal generica
      frm_lista_documentos: [], // Lista de documentos del registro
      frm_archivo: null,
      frm_descripcion_doc: "",
      f5as: [], // Listado de elementos para la tabla
      loading: false,
      noEdit: false,
    };
  }

  componentDidMount = () => {
    this.cargaTabla();
  }
  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  noEditFnc = async () => {
    let noEdit = false
    let busca = this.props.location.pathname.split("/")
    busca.shift()
    let misAmbitos = localStorage.ambitos.split(",")

    if (busca[2]) {
      let res = null
      res = await axios({
        method: "get",
        url:
          "http://143.198.191.211/api/Ambito/" +
          busca[2] +
          "?api_token=" +
          localStorage.api_token,
        data: {},
      })

      let data = res.data
      if (data.fecha_finalizado != null) {
        noEdit = true
      } else {
        if (misAmbitos.includes(busca[2])) {
          noEdit = false
        } else {
          noEdit = true
        }
      }

      if (localStorage.permisos.includes("admin")) {
        noEdit = false
      }
    }
    if (noEdit) {
      this.setState({ noEdit: true })
    } else {
      this.setState({ noEdit: false })
    }
  }

  cargaTabla = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/F5a/ambito/" +
        this.props.match.params.ambito_id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.setState({ f5as: res.data, loading: false });
    }).finally(() => {
      this.noEditFnc();
    });
  };

  cargaDocumentos = (id) => {
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/Documento/" +
        this.props.match.params.ambito_id +
        "/5a/" +
        id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.closeModalDocumentos();
      this.setState({ frm_lista_documentos: res.data, loading: false });
    });
  };

  closeModalDocumentos = () => {
    this.setState({ modalDocumentos: false });
  };

  showModalEliminar = () => {
    this.setState({ modalEliminar: true });
  };

  closeModalEliminar = () => {
    this.setState({ modalEliminar: false });
  };

  showModalVisualizar = () => {
    this.setState({ modalVisualizar: true });
  };

  closeModalVisualizar = () => {
    this.setState({ modalVisualizar: false });
  };

  showModal = () => {
    this.setState({ modal: true });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  ModalNuevo = () => {
    this.showModal();
    this.setState({
      modalLabel: "Guardar",
      variante: "primary",
      modalAccion: "insert",
      modalTitle: "Registro nuevo",
      id: "",
      no_de_expediente: "",
      conducta: "",
      origen: "",
      fecha_de_inicio: null,
      calificacion_de_la_conducta: "",
      fecha_de_remision_del_informe: null,
      seguimiento: "",
      total_de_tomos: 0,
      numero_de_fojas: 0,
      observaciones: "",
      usuario_id: "",
      ambito_id: "",
    });
  };

  ModalModificar = (row) => {
    this.showModal();
    this.setState({
      modalLabel: "Modificar",
      variante: "warning",
      modalAccion: "update",
      modalTitle: "Modificación",
      id: row.id,
      no_de_expediente: row.no_de_expediente,
      conducta: row.conducta,
      origen: row.origen,
      fecha_de_inicio: row.fecha_de_inicio,
      calificacion_de_la_conducta: row.calificacion_de_la_conducta,
      fecha_de_remision_del_informe: row.fecha_de_remision_del_informe,
      seguimiento: row.seguimiento,
      total_de_tomos: row.total_de_tomos,
      numero_de_fojas: row.numero_de_fojas,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalVisualizar = (row) => {
    this.cargaDocumentos(row.id);
    this.showModalVisualizar();
    this.setState({
      modalLabel: "Visualizar",
      variante: "warning",
      modalAccion: "view",
      modalTitle: "Visualizar",
      id: row.id,
      no_de_expediente: row.no_de_expediente,
      conducta: row.conducta,
      origen: row.origen,
      fecha_de_inicio: row.fecha_de_inicio,
      calificacion_de_la_conducta: row.calificacion_de_la_conducta,
      fecha_de_remision_del_informe: row.fecha_de_remision_del_informe,
      seguimiento: row.seguimiento,
      total_de_tomos: row.total_de_tomos,
      numero_de_fojas: row.numero_de_fojas,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalEliminar = (row) => {
    this.showModalEliminar();
    this.setState({
      modalAccion: "delete",
      id: row.id,
      no_de_expediente: row.no_de_expediente,
      conducta: row.conducta,
      origen: row.origen,
      fecha_de_inicio: row.fecha_de_inicio,
      calificacion_de_la_conducta: row.calificacion_de_la_conducta,
      fecha_de_remision_del_informe: row.fecha_de_remision_del_informe,
      seguimiento: row.seguimiento,
      total_de_tomos: row.total_de_tomos,
      numero_de_fojas: row.numero_de_fojas,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ejecutar = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    switch (this.state.modalAccion) {
      case "update":
        this.actualiza();
        break;
      case "insert":
        this.registra();
        break;
      case "delete":
        this.borra();
        break;
      default:
    }
  };

  registra = () => {
    let data = {
      //Recoger la información para el registro
      no_de_expediente: this.state.no_de_expediente,
      conducta: this.state.conducta,
      origen: this.state.origen,
      fecha_de_inicio: this.state.fecha_de_inicio,
      calificacion_de_la_conducta: this.state.calificacion_de_la_conducta,
      fecha_de_remision_del_informe: this.state.fecha_de_remision_del_informe,
      seguimiento: this.state.seguimiento,
      total_de_tomos: this.state.total_de_tomos,
      numero_de_fojas: this.state.numero_de_fojas,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios.post("http://143.198.191.211/api/F5a", data, config).then((res) => {
      this.closeModal();
      toast.success(res.data.text, { autoClose: 1000 });
      this.cargaTabla();
      this.setState({ loading: false });
    });
  };

  actualiza = () => {
    let data = {
      //Recoger la información para el registro
      id: this.state.id,
      no_de_expediente: this.state.no_de_expediente,
      conducta: this.state.conducta,
      origen: this.state.origen,
      fecha_de_inicio: this.state.fecha_de_inicio,
      calificacion_de_la_conducta: this.state.calificacion_de_la_conducta,
      fecha_de_remision_del_informe: this.state.fecha_de_remision_del_informe,
      seguimiento: this.state.seguimiento,
      total_de_tomos: this.state.total_de_tomos,
      numero_de_fojas: this.state.numero_de_fojas,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios
      .put("http://143.198.191.211/api/F5a/" + this.state.id, data, config)
      .then((res) => {
        this.closeModal();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  borra = () => {
    let data = {
      api_token: localStorage.api_token,
    };
    let config = {};
    axios
      .delete(
        "http://143.198.191.211/api/F5a/" +
        this.state.id +
        "?api_token=" +
        localStorage.api_token,
        data,
        config
      )
      .then((res) => {
        this.closeModalEliminar();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  onChangeNoDeExpediente = e => {
    this.setState({ no_de_expediente: e.target.value });
  };

  onChangeConducta = e => {
    this.setState({ conducta: e.target.value });
  };

  onChangeOrigen = e => {
    this.setState({ origen: e.target.value });
  };

  onChangeFechaDeInicio = e => {
    this.setState({ fecha_de_inicio: e.target.value });
  };

  onChangeCalificacionDeLaConducta = e => {
    this.setState({ calificacion_de_la_conducta: e.target.value });
  };

  onChangeFechaDeRemisionDelInforme = e => {
    this.setState({ fecha_de_remision_del_informe: e.target.value });
  };

  onChangeSeguimiento = e => {
    this.setState({ seguimiento: e.target.value });
  };
  onChangeTotalDeTomos = e => {
    this.setState({ total_de_tomos: e.target.value });
  };
  onChangeNumeroDeFojas = e => {
    this.setState({ numero_de_fojas: e.target.value });
  };
  onChangeObservaciones = e => {
    this.setState({ observaciones: e.target.value });
  };

  onChangeUsuarioId = e => {
    this.setState({ usuario_id: e.target.value });
  };

  onChangeAmbitoId = e => {
    this.setState({ ambito_id: e.target.value });
  };

  onChangefrm_descripcion_doc = (e) => {
    this.setState({ frm_descripcion_doc: e.target.value });
  };

  GetActionFormat = (cell, row, idx, noEdit) => {
    return (
      <div>
        <ButtonGroup size="sm">
          <button
            type="button"
            className="btn btn-outline-info btn-sm"
            size="sm"
            onClick={() => this.ModalVisualizar(row)}
            data-tip="Visualizar"
          >
            <FontAwesomeIcon icon={faEye} size="lg" />
          </button>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            size="sm"
            onClick={() => this.ModalModificar(row)}
            data-tip="Modificar"
          >
            <FontAwesomeIcon icon={faEdit} size="lg" />
          </button>
          <Adjunto
            ambito_id={this.props.match.params.ambito_id}
            formato={"5a"}
            id={row.id}
            disabled={noEdit}
          />
          <button
            type="button"
            className="btn btn-outline-danger btn-sm btn-elimina"
            size="sm"
            onClick={() => this.ModalEliminar(row)}
            data-tip="Eliminar"
            disabled={noEdit}
          >
            <FontAwesomeIcon icon={faTrash} size="lg" />
          </button>
        </ButtonGroup>
      </div>
    );
  };

  render() {
    const columns = [
      {
        dataField: "no_de_expediente",
        text: "No De Expediente",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "conducta",
        text: "Conducta",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "origen",
        text: "Denunciante",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "fecha_de_inicio",
        text: "Fecha De Radicación",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "fecha_de_remision_del_informe",
        text: "Fecha De La Última Actuación",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "seguimiento",
        text: "Estado Procesal Actual",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "total_de_tomos",
        text: "Total De Tomos",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "numero_de_fojas",
        text: "Numero De Fojas",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "observaciones",
        text: "Observaciones",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },

      {
        dataField: "",
        text: "Acción",
        formatter: this.GetActionFormat,
        formatExtraData: this.state.noEdit,
        headerStyle: () => {
          return {
            width: "140px",
            zIndex: "99",
          };
        },
      },
    ];

    const { SearchBar } = Search;
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h3">Ayuda</Popover.Title>
        <Popover.Content>{this.state.input_tooltip}</Popover.Content>
      </Popover>
    );

    return (
      <Layout>
        <ToastContainer />
        <div
          id="cargando"
          className={this.state.loading ? "parentDisable" : ""}
          width="100%"
        >
          <div className="overlay-box">
            <PropagateLoader
              // css={}
              sizeUnit={"px"}
              size={25}
              color={"#000000"}
              loading={this.state.loading}
            />
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col">
              <h3 className="d-inline">RELACIÓN DE ASUNTOS DE INVESTIGACIÓN EN TRÁMITE</h3>
              <br />
              <small className="text-muted">
                Gestione la información del anexo numero 5a referente
                a relación de asuntos de investigación en trámite, para el ámbito {this.props.match.params.ambito_id}
              </small>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12 ">
              <ToolkitProvider
                keyField="id"
                data={this.state.f5as}
                columns={columns}
                bootstrap4
                search
              >
                {(props) => (
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <ButtonToolbar aria-label="Toolbar with button groups">
                          <ButtonGroup
                            className="mr-2"
                            aria-label="First group"
                          >
                            <button
                              className="btn btn-primary btn-nuevo"
                              onClick={this.ModalNuevo}
                              data-tip="Nuevo"
                              disabled={this.state.noEdit}
                            >
                              <FontAwesomeIcon icon={faPlus} /> Nuevo
                            </button>
                          </ButtonGroup>
                          <ButtonGroup
                            className="mr-2"
                            aria-label="Second group"
                          >
                            <ReportePDF ambito_id={this.props.match.params.ambito_id}
                              anexo="5a" />
                            <a
                              className="btn btn-primary"
                              data-tip="Descarga Excel"
                              target="_blank"
                              href={
                                "http://143.198.191.211/xlsx/?a=" +
                                this.props.match.params.ambito_id +
                                "&f=5a"
                              }
                            >
                              <FontAwesomeIcon icon={faFileExcel} /> Descargar
                              Excel
                            </a>
                          </ButtonGroup>
                        </ButtonToolbar>
                      </div>
                      <div className="col-6 text-right">
                        <SearchBar
                          placeholder="Buscar..."
                          {...props.searchProps}
                          className="self-align-end"
                        />
                      </div>
                    </div>

                    <BootstrapTable
                      {...props.baseProps}
                      pagination={paginationFactory()}
                      hover
                    />
                  </div>
                )}
              </ToolkitProvider>{" "}
            </div>
          </div>
        </div>

        <Modal //***************************Modal para nuevo y modificar
          show={this.state.modal}
          onHide={this.closeModal}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Row>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  No De Expediente:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="no_de_expediente"
                  value={this.state.no_de_expediente}
                  onChange={this.onChangeNoDeExpediente}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Conducta:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="conducta"
                  value={this.state.conducta}
                  onChange={this.onChangeConducta}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Denunciante:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="origen"
                  value={this.state.origen}
                  onChange={this.onChangeOrigen}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Fecha De Radicación:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="fecha_de_inicio"
                  value={this.state.fecha_de_inicio}
                  onChange={this.onChangeFechaDeInicio}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Fecha De La Última Actuación:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="fecha_de_remision_del_informe"
                  value={this.state.fecha_de_remision_del_informe}
                  onChange={this.onChangeFechaDeRemisionDelInforme}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Estado Procesal Actual:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="seguimiento"
                  value={this.state.seguimiento}
                  onChange={this.onChangeSeguimiento}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Total De Tomos:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="number"
                  name="total_de_tomos"
                  value={this.state.total_de_tomos}
                  onChange={this.onChangeTotalDeTomos}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Numero de Fojas:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="number"
                  name="numero_de_fojas"
                  value={this.state.numero_de_fojas}
                  onChange={this.onChangeNumeroDeFojas}
                />
              </Col>
              <Col xs="12" md="12" lg="12">
                <Form.Label>
                  Observaciones:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="observaciones"
                  value={this.state.observaciones}
                  onChange={this.onChangeObservaciones}
                />
              </Col>
            </Form.Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Cancelar
            </Button>
            <Button variant={this.state.variante} onClick={this.ejecutar} className="btn-ejecutar" disabled={this.state.noEdit} >
              {this.state.modalLabel}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para eliminar
          show={this.state.modalEliminar}
          onHide={this.closeModalEliminar}
          size="sm"
          centered
        >
          <Modal.Header>
            <Modal.Title>Eliminar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Seguro que desea eliminar este registro{" "}
            <strong>{this.state.nom_direccion}</strong> ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalEliminar}>
              Cancelar
            </Button>
            <Button variant="danger" onClick={this.ejecutar} disabled={this.state.noEdit}>
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para visializar
          show={this.state.modalVisualizar}
          onHide={this.closeModalVisualizar}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header>
            <Modal.Title>Visualizar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Modal.Body className="show-grid">
              <Row>
                <Col xs={12} md={8}>
                  <h5>Datos del Registro</h5>
                  <Row>
                    <Col xs={2} className="text-muted">
                      No De Expediente:
                    </Col>
                    <Col xs={10}>{this.state.no_de_expediente}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Falta:
                    </Col>
                    <Col xs={10}>{this.state.falta}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Tipo De Falta:
                    </Col>
                    <Col xs={10}>{this.state.tipo_de_falta}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Presunto Responsable:
                    </Col>
                    <Col xs={10}>{this.state.presunto_responsable}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Fecha De Radicacion:
                    </Col>
                    <Col xs={10}>{this.state.fecha_de_radicacion}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Fecha De Ultima Actuacion:
                    </Col>
                    <Col xs={10}>{this.state.fecha_de_ultima_actuacion}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Estado Juridico Actual:
                    </Col>
                    <Col xs={10}>{this.state.estado_juridico_actual}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Numero De Fojas:
                    </Col>
                    <Col xs={10}>{this.state.numero_de_fojas}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Observaciones:
                    </Col>
                    <Col xs={10}>{this.state.observaciones}</Col>
                  </Row>

                </Col>
                <Col xs={12} md={4}>
                  <Row>
                    <Col xs={12}>
                      <h5>Archivos Adjuntos</h5>
                    </Col>
                    <Col xs={12}>
                      <ListaAdjuntos archivos={this.state.frm_lista_documentos} cargaDocumentos={this.cargaDocumentos} rowId={this.state.id} />
                    </Col>
                    <Col xs={12}>
                      <Galeria imagenes={this.state.frm_lista_documentos} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalVisualizar}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
        <ReactTooltip />
      </Layout >
    );
  }
}

export default F5as;
